module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc_title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/itr#ba1",
      "id": "ab1"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ack#ba2",
      "id": "ab2"
    }
  }, [_vm._v("Acknowledgments")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ETTING THE ")]), _vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TAGE ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/c01#ba3",
      "id": "ab3"
    }
  }, [_c('b', [_vm._v("13.7 Billion B.C.")]), _vm._v(" Big Bang")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/c01#ba4",
      "id": "ab4"
    }
  }, [_c('b', [_vm._v("3 Billion B.C.")]), _vm._v(" Black Diamonds")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/c01#ba5",
      "id": "ab5"
    }
  }, [_c('b', [_vm._v("2 Billion B.C.")]), _vm._v(" Prehistoric Nuclear Reactor")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ")]), _vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISCOVERIES ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/c01#ba6",
      "id": "ab6"
    }
  }, [_c('b', [_vm._v("30,000 B.C.")]), _vm._v(" Atlatl")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/c01#ba7",
      "id": "ab7"
    }
  }, [_c('b', [_vm._v("20,000 B.C.")]), _vm._v(" Boomerang")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/c01#ba8",
      "id": "ab8"
    }
  }, [_c('b', [_vm._v("3000 B.C.")]), _vm._v(" Sundial")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/c01#ba9",
      "id": "ab9"
    }
  }, [_c('b', [_vm._v("2500 B.C.")]), _vm._v(" Truss")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/c01#ba10",
      "id": "ab10"
    }
  }, [_c('b', [_vm._v("1850 B.C.")]), _vm._v(" Arch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/c01#ba11",
      "id": "ab11"
    }
  }, [_c('b', [_vm._v("1000 B.C.")]), _vm._v(" Olmec Compass")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/c01#ba12",
      "id": "ab12"
    }
  }, [_c('b', [_vm._v("341 B.C.")]), _vm._v(" Crossbow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/c01#ba13",
      "id": "ab13"
    }
  }, [_c('b', [_vm._v("250 B.C.")]), _vm._v(" Baghdad Battery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/c01#ba14",
      "id": "ab14"
    }
  }, [_c('b', [_vm._v("250 B.C.")]), _vm._v(" Siphon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/c01#ba15",
      "id": "ab15"
    }
  }, [_c('b', [_vm._v("250 B.C.")]), _vm._v(" Archimedes’ Principle of Buoyancy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/c01#ba16",
      "id": "ab16"
    }
  }, [_c('b', [_vm._v("250 B.C.")]), _vm._v(" Archimedean Screw")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/c01#ba17",
      "id": "ab17"
    }
  }, [_c('b', [_vm._v("240 B.C.")]), _vm._v(" Eratosthenes Measures the Earth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/c01#ba18",
      "id": "ab18"
    }
  }, [_c('b', [_vm._v("230 B.C.")]), _vm._v(" Pulley")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/c01#ba19",
      "id": "ab19"
    }
  }, [_c('b', [_vm._v("212 B.C.")]), _vm._v(" Archimedes’ Burning Mirrors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/c01#ba20",
      "id": "ab20"
    }
  }, [_c('b', [_vm._v("125 B.C.")]), _vm._v(" Antikythera Mechanism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/c01#ba21",
      "id": "ab21"
    }
  }, [_c('b', [_vm._v("50")]), _vm._v(" Hero’s Jet Engine")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/c01#ba22",
      "id": "ab22"
    }
  }, [_c('b', [_vm._v("50")]), _vm._v(" Gears")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/c01#ba23",
      "id": "ab23"
    }
  }, [_c('b', [_vm._v("78")]), _vm._v(" St. Elmo’s Fire")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/c01#ba24",
      "id": "ab24"
    }
  }, [_c('b', [_vm._v("1132")]), _vm._v(" Cannon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/c01#ba25",
      "id": "ab25"
    }
  }, [_c('b', [_vm._v("1150")]), _vm._v(" Perpetual Motion Machines")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/c01#ba26",
      "id": "ab26"
    }
  }, [_c('b', [_vm._v("1200")]), _vm._v(" Trebuchet")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/c01#ba27",
      "id": "ab27"
    }
  }, [_c('b', [_vm._v("1304")]), _vm._v(" Explaining the Rainbow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/c01#ba28",
      "id": "ab28"
    }
  }, [_c('b', [_vm._v("1338")]), _vm._v(" Hourglass")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/c01#ba29",
      "id": "ab29"
    }
  }, [_c('b', [_vm._v("1543")]), _vm._v(" Sun-Centered Universe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/c01#ba30",
      "id": "ab30"
    }
  }, [_c('b', [_vm._v("1596")]), _vm._v(" "), _c('i', [_vm._v("Mysterium Cosmographicum")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/c01#ba31",
      "id": "ab31"
    }
  }, [_c('b', [_vm._v("1600")]), _vm._v(" "), _c('i', [_vm._v("De Magnete")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/c01#ba32",
      "id": "ab32"
    }
  }, [_c('b', [_vm._v("1608")]), _vm._v(" Telescope")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/c01#ba33",
      "id": "ab33"
    }
  }, [_c('b', [_vm._v("1609")]), _vm._v(" Kepler’s Laws of Planetary Motion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/c01#ba34",
      "id": "ab34"
    }
  }, [_c('b', [_vm._v("1610")]), _vm._v(" Discovery of Saturn’s Rings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/c01#ba35",
      "id": "ab35"
    }
  }, [_c('b', [_vm._v("1611")]), _vm._v(" Kepler’s “Six-Cornered Snowflake”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/c01#ba36",
      "id": "ab36"
    }
  }, [_c('b', [_vm._v("1620")]), _vm._v(" Triboluminescence")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/c01#ba37",
      "id": "ab37"
    }
  }, [_c('b', [_vm._v("1621")]), _vm._v(" Snell’s Law of Refraction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/c01#ba38",
      "id": "ab38"
    }
  }, [_c('b', [_vm._v("1621")]), _vm._v(" Aurora Borealis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/c01#ba39",
      "id": "ab39"
    }
  }, [_c('b', [_vm._v("1638")]), _vm._v(" Acceleration of Falling Objects")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/c01#ba40",
      "id": "ab40"
    }
  }, [_c('b', [_vm._v("1643")]), _vm._v(" Barometer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/c01#ba41",
      "id": "ab41"
    }
  }, [_c('b', [_vm._v("1644")]), _vm._v(" Conservation of Momentum")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/c01#ba42",
      "id": "ab42"
    }
  }, [_c('b', [_vm._v("1660")]), _vm._v(" Hooke’s Law of Elasticity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/c01#ba43",
      "id": "ab43"
    }
  }, [_c('b', [_vm._v("1660")]), _vm._v(" Von Guericke’s Electrostatic Generator")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/c01#ba44",
      "id": "ab44"
    }
  }, [_c('b', [_vm._v("1662")]), _vm._v(" Boyle’s Gas Law")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba45",
      "id": "ab45",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1665")]), _vm._v(" "), _c('i', [_vm._v("Micrographia")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba46",
      "id": "ab46",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1669")]), _vm._v(" Amontons’ Friction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba47",
      "id": "ab47",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1672")]), _vm._v(" Measuring the Solar System")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba48",
      "id": "ab48",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1672")]), _vm._v(" Newton’s Prism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba49",
      "id": "ab49",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1673")]), _vm._v(" Tautochrone Ramp")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba50",
      "id": "ab50",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1687")]), _vm._v(" Newton’s Laws of Motion and Gravitation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba51",
      "id": "ab51",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1687")]), _vm._v(" Newton as Inspiration")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba52",
      "id": "ab52",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1711")]), _vm._v(" Tuning Fork")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba53",
      "id": "ab53",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1728")]), _vm._v(" Escape Velocity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba54",
      "id": "ab54",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1738")]), _vm._v(" Bernoulli’s Law of Fluid Dynamics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba55",
      "id": "ab55",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1744")]), _vm._v(" Leyden Jar")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba56",
      "id": "ab56",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1752")]), _vm._v(" Ben Franklin’s Kite")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba57",
      "id": "ab57",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1761")]), _vm._v(" Black Drop Effect")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba58",
      "id": "ab58",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1766")]), _vm._v(" Bode’s Law of Planetary Distances")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba59",
      "id": "ab59",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1777")]), _vm._v(" Lichtenberg Figures")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba60",
      "id": "ab60",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1779")]), _vm._v(" Black Eye Galaxy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba61",
      "id": "ab61",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1783")]), _vm._v(" Black Holes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba62",
      "id": "ab62",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1785")]), _vm._v(" Coulomb’s Law of Electrostatics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba63",
      "id": "ab63",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1787")]), _vm._v(" Charles’ Gas Law")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba64",
      "id": "ab64",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1796")]), _vm._v(" Nebular Hypothesis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba65",
      "id": "ab65",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1798")]), _vm._v(" Cavendish Weighs the Earth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba66",
      "id": "ab66",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1800")]), _vm._v(" Battery")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba67",
      "id": "ab67",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1801")]), _vm._v(" Wave Nature of Light")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba68",
      "id": "ab68",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1803")]), _vm._v(" Henry’s Gas Law")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba69",
      "id": "ab69",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1807")]), _vm._v(" Fourier Analysis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba70",
      "id": "ab70",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1808")]), _vm._v(" Atomic Theory")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba71",
      "id": "ab71",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1811")]), _vm._v(" Avogadro’s Gas Law")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba72",
      "id": "ab72",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1814")]), _vm._v(" Fraunhofer Lines")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba73",
      "id": "ab73",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1814")]), _vm._v(" Laplace’s Demon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba74",
      "id": "ab74",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1815")]), _vm._v(" Brewster’s Optics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba75",
      "id": "ab75",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1816")]), _vm._v(" Stethoscope")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba76",
      "id": "ab76",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1822")]), _vm._v(" Fourier’s Law of Heat Conduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba77",
      "id": "ab77",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1823")]), _vm._v(" Olbers’ Paradox")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba78",
      "id": "ab78",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1824")]), _vm._v(" Greenhouse Effect")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba79",
      "id": "ab79",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1824")]), _vm._v(" Carnot Engine")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba80",
      "id": "ab80",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1825")]), _vm._v(" Ampère’s Law of Electromagnetism")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba81",
      "id": "ab81",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1826")]), _vm._v(" Rogue Waves")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba82",
      "id": "ab82",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1827")]), _vm._v(" Ohm’s Law of Electricity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba83",
      "id": "ab83",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1827")]), _vm._v(" Brownian Motion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba84",
      "id": "ab84",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1829")]), _vm._v(" Graham’s Law of Effusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba85",
      "id": "ab85",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1831")]), _vm._v(" Faraday’s Laws of Induction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba86",
      "id": "ab86",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1834")]), _vm._v(" Soliton")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba87",
      "id": "ab87",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1835")]), _vm._v(" Gauss and the Magnetic Monopole")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba88",
      "id": "ab88",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1838")]), _vm._v(" Stellar Parallax")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba89",
      "id": "ab89",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1839")]), _vm._v(" Fuel Cell")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba90",
      "id": "ab90",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1840")]), _vm._v(" Poiseuille’s Law of Fluid Flow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba91",
      "id": "ab91",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1840")]), _vm._v(" Joule’s Law of Electric Heating")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba92",
      "id": "ab92",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1841")]), _vm._v(" Anniversary Clock")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba93",
      "id": "ab93",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1841")]), _vm._v(" Fiber Optics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba94",
      "id": "ab94",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1842")]), _vm._v(" Doppler Effect")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba95",
      "id": "ab95",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1843")]), _vm._v(" Conservation of Energy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba96",
      "id": "ab96",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1844")]), _vm._v(" I-Beams")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba97",
      "id": "ab97",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1845")]), _vm._v(" Kirchhoff’s Circuit Laws")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba98",
      "id": "ab98",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1846")]), _vm._v(" Discovery of Neptune")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba99",
      "id": "ab99",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1850")]), _vm._v(" Second Law of Thermodynamics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba100",
      "id": "ab100",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1850")]), _vm._v(" Ice Slipperiness")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba101",
      "id": "ab101",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1851")]), _vm._v(" Foucault’s Pendulum")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba102",
      "id": "ab102",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1851")]), _vm._v(" Stokes’ Law of Viscosity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba103",
      "id": "ab103",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1852")]), _vm._v(" Gyroscope")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba104",
      "id": "ab104",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1852")]), _vm._v(" Stokes’ Fluorescence")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba105",
      "id": "ab105",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1857")]), _vm._v(" Buys-Ballot’s Weather Law")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba106",
      "id": "ab106",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1859")]), _vm._v(" Kinetic Theory")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba107",
      "id": "ab107",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1861")]), _vm._v(" Maxwell’s Equations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba108",
      "id": "ab108",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1864")]), _vm._v(" Electromagnetic Spectrum")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba109",
      "id": "ab109",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1866")]), _vm._v(" Surface Tension")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba110",
      "id": "ab110",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1866")]), _vm._v(" Dynamite")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba111",
      "id": "ab111",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1867")]), _vm._v(" Maxwell’s Demon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba112",
      "id": "ab112",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1868")]), _vm._v(" Discovery of Helium")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba113",
      "id": "ab113",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1870")]), _vm._v(" Baseball Curveball")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba114",
      "id": "ab114",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1871")]), _vm._v(" Rayleigh Scattering")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba115",
      "id": "ab115",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1873")]), _vm._v(" Crookes Radiometer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba116",
      "id": "ab116",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1875")]), _vm._v(" Boltzmann’s Entropy Equation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba117",
      "id": "ab117",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1878")]), _vm._v(" Incandescent Light Bulb")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba118",
      "id": "ab118",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1879")]), _vm._v(" Plasma")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba119",
      "id": "ab119",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1879")]), _vm._v(" Hall Effect")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba120",
      "id": "ab120",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1880")]), _vm._v(" Piezoelectric Effect")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba121",
      "id": "ab121",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1880")]), _vm._v(" War Tubas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba122",
      "id": "ab122",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1882")]), _vm._v(" Galvanometer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba123",
      "id": "ab123",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1882")]), _vm._v(" Green Flash")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba124",
      "id": "ab124",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1887")]), _vm._v(" Michelson-Morley Experiment")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba125",
      "id": "ab125",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1889")]), _vm._v(" Birth of the Kilogram")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba126",
      "id": "ab126",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1889")]), _vm._v(" Birth of the Meter")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba127",
      "id": "ab127",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1890")]), _vm._v(" Eötvös’ Gravitational Gradiometry")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba128",
      "id": "ab128",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1891")]), _vm._v(" Tesla Coil")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba129",
      "id": "ab129",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1892")]), _vm._v(" Thermos")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba130",
      "id": "ab130",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1895")]), _vm._v(" X-rays")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba131",
      "id": "ab131",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1895")]), _vm._v(" Curie’s Magnetism Law")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba132",
      "id": "ab132",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1896")]), _vm._v(" Radioactivity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba133",
      "id": "ab133",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1897")]), _vm._v(" Electron")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba134",
      "id": "ab134",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1898")]), _vm._v(" Mass Spectrometer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02#ba135",
      "id": "ab135",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1900")]), _vm._v(" Blackbody Radiation Law")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02a#ba136",
      "id": "ab136",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1901")]), _vm._v(" Clothoid Loop")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02a#ba137",
      "id": "ab137",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1903")]), _vm._v(" Black Light")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02a#ba138",
      "id": "ab138",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1903")]), _vm._v(" Tsiolkovsky Rocket Equation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02a#ba139",
      "id": "ab139",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1904")]), _vm._v(" Lorentz Transformation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02a#ba140",
      "id": "ab140",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1905")]), _vm._v(" Special Theory of Relativity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c02a#ba141",
      "id": "ab141",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1905")]), _vm._v(" "), _c('i', [_vm._v("E = mc"), _c('sup', [_vm._v("2")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c03#ba142",
      "id": "ab142",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1905")]), _vm._v(" Photoelectric Effect")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c03#ba143",
      "id": "ab143",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1905")]), _vm._v(" Golf Ball Dimples")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c03#ba144",
      "id": "ab144",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1905")]), _vm._v(" Third Law of Thermodynamics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c03#ba145",
      "id": "ab145",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1906")]), _vm._v(" Vacuum Tube")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c03#ba146",
      "id": "ab146",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1908")]), _vm._v(" Geiger Counter")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c03#ba147",
      "id": "ab147",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1909")]), _vm._v(" Bremsstrahlung")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c03#ba148",
      "id": "ab148",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1910")]), _vm._v(" Cosmic Rays")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c03#ba149",
      "id": "ab149",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1911")]), _vm._v(" Superconductivity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c03#ba150",
      "id": "ab150",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1911")]), _vm._v(" Atomic Nucleus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c03#ba151",
      "id": "ab151",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1911")]), _vm._v(" Kármán Vortex Street")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c03#ba152",
      "id": "ab152",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1911")]), _vm._v(" Wilson Cloud Chamber")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c03#ba153",
      "id": "ab153",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1912")]), _vm._v(" Cepheid Variables Measure the Universe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c03#ba154",
      "id": "ab154",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1912")]), _vm._v(" Bragg’s Law of Crystal Diffraction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c03#ba155",
      "id": "ab155",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1913")]), _vm._v(" Bohr Atom")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c03#ba156",
      "id": "ab156",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1913")]), _vm._v(" Millikan Oil Drop Experiment")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c03#ba157",
      "id": "ab157",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1915")]), _vm._v(" General Theory of Relativity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c03#ba158",
      "id": "ab158",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1919")]), _vm._v(" String Theory")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c03#ba159",
      "id": "ab159",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1921")]), _vm._v(" Einstein as Inspiration")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c03#ba160",
      "id": "ab160",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1922")]), _vm._v(" Stern-Gerlach Experiment")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c03#ba161",
      "id": "ab161",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1923")]), _vm._v(" Neon Signs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c03#ba162",
      "id": "ab162",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1923")]), _vm._v(" Compton Effect")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c03#ba163",
      "id": "ab163",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1924")]), _vm._v(" De Broglie Relation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c03#ba164",
      "id": "ab164",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1925")]), _vm._v(" Pauli Exclusion Principle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c03#ba165",
      "id": "ab165",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1926")]), _vm._v(" Schrödinger’s Wave Equation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c03#ba166",
      "id": "ab166",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1927")]), _vm._v(" Heisenberg Uncertainty Principle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c03#ba167",
      "id": "ab167",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1927")]), _vm._v(" Complementarity Principle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c03#ba168",
      "id": "ab168",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1927")]), _vm._v(" Hypersonic Whipcracking")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c03#ba169",
      "id": "ab169",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1928")]), _vm._v(" Dirac Equation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c03#ba170",
      "id": "ab170",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1928")]), _vm._v(" Quantum Tunneling")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c03#ba171",
      "id": "ab171",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1929")]), _vm._v(" Hubble’s Law of Cosmic Expansion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c03#ba172",
      "id": "ab172",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1929")]), _vm._v(" Cyclotron")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c03#ba173",
      "id": "ab173",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1931")]), _vm._v(" White Dwarfs and Chandrasekhar Limit")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c03#ba174",
      "id": "ab174",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1931")]), _vm._v(" Jacob’s Ladder")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c03#ba175",
      "id": "ab175",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1932")]), _vm._v(" Neutron")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c03#ba176",
      "id": "ab176",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1932")]), _vm._v(" Antimatter")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c03#ba177",
      "id": "ab177",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1933")]), _vm._v(" Dark Matter")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c03#ba178",
      "id": "ab178",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1933")]), _vm._v(" Neutron Stars")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c03#ba179",
      "id": "ab179",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1934")]), _vm._v(" Cherenkov Radiation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c03#ba180",
      "id": "ab180",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1934")]), _vm._v(" Sonoluminescence")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c03#ba181",
      "id": "ab181",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1935")]), _vm._v(" EPR Paradox")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c03#ba182",
      "id": "ab182",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1935")]), _vm._v(" Schrödinger’s Cat")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c03#ba183",
      "id": "ab183",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1937")]), _vm._v(" Superfluids")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c03#ba184",
      "id": "ab184",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1938")]), _vm._v(" Nuclear Magnetic Resonance")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c03#ba185",
      "id": "ab185",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1942")]), _vm._v(" Energy from the Nucleus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c03#ba186",
      "id": "ab186",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1943")]), _vm._v(" Silly Putty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c03#ba187",
      "id": "ab187",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1945")]), _vm._v(" Drinking Bird")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c03#ba188",
      "id": "ab188",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1945")]), _vm._v(" Little Boy Atomic Bomb")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c03#ba189",
      "id": "ab189",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1946")]), _vm._v(" Stellar Nucleosynthesis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c03#ba190",
      "id": "ab190",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1947")]), _vm._v(" Transistor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c03#ba191",
      "id": "ab191",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1947")]), _vm._v(" Sonic Booms")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c03#ba192",
      "id": "ab192",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1947")]), _vm._v(" Hologram")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c03#ba193",
      "id": "ab193",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1948")]), _vm._v(" Quantum Electrodynamics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba194",
      "id": "ab194",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1948")]), _vm._v(" Tensegrity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba195",
      "id": "ab195",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1948")]), _vm._v(" Casimir Effect")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba196",
      "id": "ab196",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1949")]), _vm._v(" Time Travel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba197",
      "id": "ab197",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1949")]), _vm._v(" Radiocarbon Dating")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba198",
      "id": "ab198",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1950")]), _vm._v(" Fermi Paradox")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba199",
      "id": "ab199",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1954")]), _vm._v(" Solar Cells")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba200",
      "id": "ab200",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1955")]), _vm._v(" Leaning Tower of Lire")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba201",
      "id": "ab201",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1955")]), _vm._v(" Seeing the Single Atom")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba202",
      "id": "ab202",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1955")]), _vm._v(" Atomic Clocks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba203",
      "id": "ab203",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1956")]), _vm._v(" Parallel Universes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba204",
      "id": "ab204",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1956")]), _vm._v(" Neutrinos")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba205",
      "id": "ab205",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1956")]), _vm._v(" Tokamak")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba206",
      "id": "ab206",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1958")]), _vm._v(" Integrated Circuit")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba207",
      "id": "ab207",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1959")]), _vm._v(" Dark Side of the Moon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba208",
      "id": "ab208",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1960")]), _vm._v(" Dyson Sphere")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba209",
      "id": "ab209",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1960")]), _vm._v(" Laser")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba210",
      "id": "ab210",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1960")]), _vm._v(" Terminal Velocity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba211",
      "id": "ab211",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1961")]), _vm._v(" Anthropic Principle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba212",
      "id": "ab212",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1961")]), _vm._v(" Standard Model")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba213",
      "id": "ab213",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1962")]), _vm._v(" Electromagnetic Pulse")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba214",
      "id": "ab214",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1963")]), _vm._v(" Chaos Theory")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba215",
      "id": "ab215",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1963")]), _vm._v(" Quasars")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba216",
      "id": "ab216",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1963")]), _vm._v(" Lava Lamp")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba217",
      "id": "ab217",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1964")]), _vm._v(" The God Particle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba218",
      "id": "ab218",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1964")]), _vm._v(" Quarks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba219",
      "id": "ab219",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1964")]), _vm._v(" CP Violation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba220",
      "id": "ab220",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1964")]), _vm._v(" Bell’s Theorem")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba221",
      "id": "ab221",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1965")]), _vm._v(" Super Ball")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba222",
      "id": "ab222",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1965")]), _vm._v(" Cosmic Microwave Background")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba223",
      "id": "ab223",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1967")]), _vm._v(" Gamma-Ray Bursts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba224",
      "id": "ab224",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1967")]), _vm._v(" Living in a Simulation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba225",
      "id": "ab225",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1967")]), _vm._v(" Tachyons")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba226",
      "id": "ab226",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1967")]), _vm._v(" Newton’s Cradle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba227",
      "id": "ab227",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1967")]), _vm._v(" Metamaterials")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba228",
      "id": "ab228",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1969")]), _vm._v(" Unilluminable Rooms")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba229",
      "id": "ab229",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1971")]), _vm._v(" Supersymmetry")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba230",
      "id": "ab230",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1980")]), _vm._v(" Cosmic Inflation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba231",
      "id": "ab231",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1981")]), _vm._v(" Quantum Computers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba232",
      "id": "ab232",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1982")]), _vm._v(" Quasicrystals")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba233",
      "id": "ab233",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1984")]), _vm._v(" Theory of Everything")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba234",
      "id": "ab234",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1985")]), _vm._v(" Buckyballs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba235",
      "id": "ab235",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1987")]), _vm._v(" Quantum Immortality")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba236",
      "id": "ab236",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1987")]), _vm._v(" Self-Organized Criticality")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba237",
      "id": "ab237",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1988")]), _vm._v(" Wormhole Time Machine")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba238",
      "id": "ab238",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1990")]), _vm._v(" Hubble Telescope")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba239",
      "id": "ab239",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1992")]), _vm._v(" Chronology Protection Conjecture")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba240",
      "id": "ab240",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1993")]), _vm._v(" Quantum Teleportation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba241",
      "id": "ab241",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1993")]), _vm._v(" Stephen Hawking on "), _c('i', [_vm._v("Star Trek")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba242",
      "id": "ab242",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1995")]), _vm._v(" Bose-Einstein Condensate")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba243",
      "id": "ab243",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1998")]), _vm._v(" Dark Energy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba244",
      "id": "ab244",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1999")]), _vm._v(" Randall-Sundrum Branes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba245",
      "id": "ab245",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("1999")]), _vm._v(" Fastest Tornado Speed")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba246",
      "id": "ab246",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("2007")]), _vm._v(" HAARP")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba247",
      "id": "ab247",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("2008")]), _vm._v(" Blackest Black")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba248",
      "id": "ab248",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("2009")]), _vm._v(" Large Hadron Collider")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LOSING THE ")]), _vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("URTAIN ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba249",
      "id": "ab249",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("36 Billion")]), _vm._v(" Cosmological Big Rip")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba250",
      "id": "ab250",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("100 Billion")]), _vm._v(" Cosmic Isolation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba251",
      "id": "ab251",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("100 Trillion")]), _vm._v(" Universe Fades")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/c04#ba252",
      "id": "ab252",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v(">100 Trillion")]), _vm._v(" Quantum Resurrection")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#ba253",
      "id": "ab253",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes and Further Reading")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ind#ba254",
      "id": "ab254",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/bm#ba255",
      "id": "ab255",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Photo Credits")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ata#ata",
      "id": "ata1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b098e46","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/toc.vue
// module id = 75
// module chunks = 0